import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from '../views/NotFound.vue'
import Top from '../views/Top.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'top',
    component: Top
  },
  {
    path: '/top',
    redirect: '/'
  },
  {
    path: '/images/:id',
    name: 'image',
    component: Top
  },
  {
    path: '/list',
    name: 'list',
    component: Top
  },
  {
    path: '/video',
    name: 'video',
    component: Top
  },
  {
    path: '/about',
    name: 'about',
    component: Top
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  // scrollBehavior () {
  //   return { x: 0, y: 0 }
  // },
  base: process.env.BASE_URL,
  routes
})

export default router
